import { Badge, Skeleton, Table } from 'antd';
import { ColumnsType } from 'antd/lib/table';
import { useGetSingleAbsenceQuery } from 'app/services/edpApiV1/absence';
import { useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';
import { dataObjectForAbsencesTable, dataObjectForFormAbsences, sortingDate } from 'shared/helpers/utils';
import { useIndicators } from 'features/indicators';
import { TPreparedSingleAbsenceData, TPreparedSingleAbsenceTable } from 'shared/types/absence.types';
import AbsenceComment from '../AbsenceComment';
import AbsenceUserForm from '../absenceUserForm';
import style from './index.module.scss';

/**
 * @page Absence user subordinates
 */

const columns: ColumnsType<TPreparedSingleAbsenceData> = [
  {
    title: '№',
    dataIndex: 'id',
    key: 'key',
    width: 120,
  },
  {
    title: 'Дата',
    dataIndex: 'created',
    key: 'created',
    sorter: (a, b) => sortingDate(a.created, b.created),
  },
  {
    title: 'Период',
    dataIndex: 'period',
    key: 'period',
  },
  {
    title: 'ФИО',
    dataIndex: 'fio',
    key: 'fio',
  },
  {
    title: 'Статус',
    dataIndex: 'status',
    key: 'status',
    render: status => (
      <span>
        <Badge status={status.type} />
        {status.name}
      </span>
    ),
  },
];

const AbsenceUserSubordinates = () => {
  const { id } = useParams();
  const [dataAbsence, setDataAbsence] = useState<TPreparedSingleAbsenceData[] | []>([]);
  const dataForTable = useRef<TPreparedSingleAbsenceTable[]>();
  const {
    data: dataSingleAbsence,
    isLoading,
    isFetching,
    isSuccess,
  } = useGetSingleAbsenceQuery(id!, {
    skip: !id,
  });

  useEffect(() => {
    if (dataSingleAbsence) {
      const dataAbsence = dataObjectForFormAbsences(dataSingleAbsence);
      const tableData = dataObjectForAbsencesTable(dataSingleAbsence);
      dataForTable.current = tableData;
      setDataAbsence(dataAbsence);
    }
  }, [dataSingleAbsence]);

  useIndicators(isSuccess, isFetching);

  return (
    <>
      <div className={style.wrap}>
        {isLoading ? (
          <Skeleton active />
        ) : (
          <>
            <Table scroll={{ x: true }} dataSource={dataAbsence} columns={columns} pagination={false} bordered />
            {dataAbsence && <AbsenceUserForm dataAbsence={dataAbsence} />}
          </>
        )}
      </div>

      {dataAbsence && (dataAbsence[0]?.supervisorComment || dataAbsence[0]?.hrComment) && (
        <AbsenceComment dataAbsence={dataAbsence} />
      )}
    </>
  );
};

export default AbsenceUserSubordinates;
